import { render } from "./DashboardNav.vue?vue&type=template&id=2b15bd96&ts=true"
import script from "./DashboardNav.vue?vue&type=script&lang=ts"
export * from "./DashboardNav.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__